import React from 'react';
import { SEO } from '../../components/seo/SEO';
import { Newspaper, Users, Gamepad2, Repeat, Smartphone, Database, Share2, Trophy } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';

export function About() {
  const { t } = useTranslation();
  
  return (
    <>
      <SEO
        title={t('about.seo.title')}
        description={t('about.seo.description')}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">{t('about.title')}</h1>
            <p className="text-lg text-gray-600">
              {t('about.subtitle')}
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
            <div className="p-8">
              <div className="prose prose-blue max-w-none">
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-6 mb-8">
                  <div className="flex items-center mb-4">
                    <div className="bg-blue-100 p-3 rounded-lg">
                      <Smartphone className="w-6 h-6 text-blue-600" />
                    </div>
                    <h2 className="ml-4 text-2xl font-semibold text-gray-900">{t('about.intro.title')}</h2>
                  </div>
                  <p className="text-gray-600">
                    {t('about.intro.description')}
                  </p>
                </div>

                <div className="grid gap-8 md:grid-cols-2 mb-12">
                  <div className="bg-gray-50 rounded-xl p-6">
                    <div className="flex items-center mb-4">
                      <div className="bg-blue-100 p-3 rounded-lg">
                        <Database className="w-6 h-6 text-blue-600" />
                      </div>
                      <h3 className="ml-4 text-lg font-semibold text-gray-900">{t('about.features.collection.title')}</h3>
                    </div>
                    <p className="text-gray-600">
                      {t('about.features.collection.description')}
                    </p>
                  </div>

                  <div className="bg-gray-50 rounded-xl p-6">
                    <div className="flex items-center mb-4">
                      <div className="bg-blue-100 p-3 rounded-lg">
                        <Gamepad2 className="w-6 h-6 text-blue-600" />
                      </div>
                      <h3 className="ml-4 text-lg font-semibold text-gray-900">{t('about.features.deck.title')}</h3>
                    </div>
                    <p className="text-gray-600">
                      {t('about.features.deck.description')}
                    </p>
                  </div>

                  <div className="bg-gray-50 rounded-xl p-6">
                    <div className="flex items-center mb-4">
                      <div className="bg-blue-100 p-3 rounded-lg">
                        <Share2 className="w-6 h-6 text-blue-600" />
                      </div>
                      <h3 className="ml-4 text-lg font-semibold text-gray-900">{t('about.features.trades.title')}</h3>
                    </div>
                    <p className="text-gray-600">
                      {t('about.features.trades.description')}
                    </p>
                  </div>

                  <div className="bg-gray-50 rounded-xl p-6">
                    <div className="flex items-center mb-4">
                      <div className="bg-blue-100 p-3 rounded-lg">
                        <Trophy className="w-6 h-6 text-blue-600" />
                      </div>
                      <h3 className="ml-4 text-lg font-semibold text-gray-900">{t('about.features.progression.title')}</h3>
                    </div>
                    <p className="text-gray-600">
                      {t('about.features.progression.description')}
                    </p>
                  </div>
                </div>

                <div className="bg-blue-50 rounded-xl p-6 mb-8">
                  <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('about.engagement.title')}</h2>
                  <p className="text-gray-600">
                    {t('about.engagement.description')}
                  </p>
                </div>

                <div className="text-sm text-gray-500 border-t border-gray-200 pt-6">
                  <p>
                    {t('about.disclaimer')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
} 